import { navGroups } from 'src/data/listings'

// Groups are ordered here; their children come from src/data/listings
const groupOrder = ['Insights', 'Work']

export const PrimaryMenu = [
    {
        label: 'Home',
        path: '/'
    },
    ...groupOrder
        .filter(group => navGroups[group]?.length)
        .map(group => ({ label: group, children: navGroups[group] })),
]
